import {
  Entity,
  Column,
  CreateDateColumn,
  UpdateDateColumn,
  PrimaryGeneratedColumn,
} from 'typeorm';
import { AttachmentsStatus } from '../../interface/attachments/attachments-response.interface';

@Entity('attachments')
export class AttachmentsEntity {

  @PrimaryGeneratedColumn('uuid')
  id!: string;

  @Column()
  bucket_name!: string;

  @Column()
  storage_path!: string;

  @Column({ type: 'text' })
  public_url!: string;

  @Column()
  file_type!: string;

  @Column({ type: 'int'})
  file_size!: number;

  @Column()
  file_name!: string;

  @Column({ type: 'varchar' })
  status!: AttachmentsStatus;

  @CreateDateColumn()
  created_at!: Date;

  @UpdateDateColumn()
  updated_at!: Date;
}